import {axios} from "../../helpers/axios";
import { PROFILE_URL } from "../profile/profileConstants";

export const api_get_profile_list_url = async () => {
    return axios.get(PROFILE_URL, { params: { all: true } });
};


export const api_update_profile_url = async (user_id,updated_data) => {
  return axios.put(PROFILE_URL+ "/" + user_id, updated_data);
};
